import { render, staticRenderFns } from "./BrowseGames.vue?vue&type=template&id=d1e171ec&scoped=true&lang=pug&"
import script from "./BrowseGames.vue?vue&type=script&lang=js&"
export * from "./BrowseGames.vue?vue&type=script&lang=js&"
import style0 from "./BrowseGames.vue?vue&type=style&index=0&id=d1e171ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e171ec",
  null
  
)

export default component.exports